const imageSuffixes = [".gif", ".jpg", ".jpeg", ".png", ".webp", ".svg"];
const videoSuffixes = [".mpg", ".mp2", ".mpeg", ".mpe", ".mpv", ".mp4", ".webm", ".mov", ".avi"];

export const isImageOrVideo = (
	pathName: string,
): {
	isImage: boolean;
	isVideo: boolean;
} => {
	const isVimeoVideo = pathName?.toLowerCase()?.startsWith("https://vimeo.com/");
	const isYoutubeVideo = pathName?.toLowerCase()?.startsWith("https://www.youtube.com/");

	const isVideo =
		videoSuffixes?.some((suffix) => pathName?.toLowerCase()?.includes(suffix)) ||
		isVimeoVideo ||
		isYoutubeVideo;
	const isImage = imageSuffixes?.some((suffix) => pathName?.toLowerCase()?.includes(suffix));
	return {
		isVideo,
		isImage,
	};
};
